import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const ContactAdmissions = () => {
  return (
    <PlaceholderPage title="Contact Admissions">
      Our admissions team is here to help you with any questions you may have about applying to FIC College. 
      Feel free to reach out to us via phone, email, or by visiting our office.
    </PlaceholderPage>
  );
};

export default ContactAdmissions;
